import { Component, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { SWAlertService } from '../../services/swalert.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { DatePipe } from '@angular/common';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-reversefidoc',
  templateUrl: './admin-reversefidoc.component.html',
  styleUrls: ['./admin-reversefidoc.component.css']
})
export class AdminReverseFIdocComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(private http: HttpClient, private router: Router, private System: TSFuntionService, private SW: SWAlertService, private modalService: BsModalService, public datepipe: DatePipe) { }
  arrRequestID: Array<any> = [];
  arrGL: any;
  arrFIDoc: any;
  sSearch: string = "";
  sDetailData = "";
  _ArrDataFirst = [];
  _ArrData = [];
  _ArrDataBind = [];
  _FIDoc: any[] = [];
  FIDoc: any;
  ResultPermission: boolean = true;
  isResult: boolean = false;
  isShowFIDoc: boolean = false;
  isShowClearingDoc: boolean = false;
  isShowAdvClearingDoc: boolean = false;
  isShowRecieveDoc: boolean = false;

  sReverseForm = new FormGroup({
    sRequestID: new FormControl(''),
    dReversingDate: new FormControl('', Validators.required)
  });
  TODAY: Date;

  public settings = {};
  public settings_com = {};
  ArrCompany = [];
  FilterGrid = {
    sSearch: "",
    nReqTypeID: [],
    sCompanyCode: [],
    sFIDoc: "",
    sStatus: "1",
  }
  async ngOnInit() {
    this.TODAY = new Date();
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    await this.LoadDropDown();
    this.ResultPermission = await this.System.CheckPermissionMeun(46); //F = ดู, T = แก้ 
    if (this.ResultPermission == false) {
      this.isResult = true;
    }
    else {
      this.isResult = false;
    }
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
      this.getFIDocSearch(ua.sCompCode);
    }
    this.Search();
    this._ArrDataFirst = [];

  }

  _RequestType = [];

  async LoadDropDown() {
    //Type
    let GetTaskType = await this.http.get<any>(this.System.SiteName + "api/AdminReverseFIdoc/GetTaskType").toPromise();
    if (GetTaskType) {
      this._RequestType = GetTaskType;
    }
    //Company
    let GetCompany = await this.http.get<any>(this.System.SiteName + "api/AdminReverseFIdoc/GetCompany").toPromise();
    if (GetCompany) {
      this.ArrCompany = GetCompany;
    }
  }

  //#region DataGrid
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }

  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";

  //#region 2. Header Colomn
  @Output() onChange = new EventEmitter();
  Columns = [
    { ColumnName: "", SortField: "" },
    { ColumnName: "Reversed", SortField: "" },
    { ColumnName: "Request No.", SortField: "sRequestCode" },
    { ColumnName: "Request Type", SortField: "sReqType" },
    { ColumnName: "Vendor", SortField: "sVendorName" },
    { ColumnName: "Cost Center", SortField: "sCCTR" },
    { ColumnName: "Net Total", SortField: "" },
    { ColumnName: "Due Date", SortField: "" },
    { ColumnName: "Reversed Date", SortField: "" },
    { ColumnName: "Reversed Status", SortField: "", Width: "9%" }
  ]
  //#endregion

  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    let nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();

  }
  //#endregion

  async Search() {
    this._ArrDataFirst = [];
    this.System.BlockUI();
    let _this = this;
    let ReqType: string = this.FilterGrid.nReqTypeID.length > 0 ? this.FilterGrid.nReqTypeID.map(e => e.sValue).join(",") : "";
    let sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.COMPANY_CODE).join(",") : "";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('sReqType', ReqType)
        .set('sCompanyCode', sCompanyCode)
        .set('sFIDoc', this.FilterGrid.sFIDoc)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdminReverseFIdoc/Search", httpOptions).toPromise().then(Data => {
      if (Data) {
        _this._ArrData = Data;
        if (_this._ArrDataFirst.length == 0) {
          _this._ArrData.forEach(function (item) {
            _this._ArrDataFirst.push({ sRequestID: item.sRequestID, IsChecked: false });
          })
        }

        //Update Check ให้กลับมา
        let DATA_CHECK = _this._ArrDataFirst.filter(f => f.IsChecked == true);
        DATA_CHECK.forEach(function (Item) {
          //แก้ไขข้อมูลผ่าน Array ที่มาจาก Database
          let DATA_BY_BASE = _this._ArrData.filter(f => f.sRequestID == Item.sRequestID);
          if (DATA_BY_BASE.length > 0) {
            DATA_BY_BASE[0].IsChecked = Item.IsChecked;
          }
        })
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }

  onClick(value: string) {
    let _this = this;
    if (value == "Back") {
      this.router.navigate(["/admin-menu"]);
    }
  }

  onClear() {
    this.FilterGrid.nReqTypeID = [];
    this.FilterGrid.sSearch = "";
    this.FilterGrid.sFIDoc = "";
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
      this.getFIDocSearch(ua.sCompCode);
    }
    this.Search();
  }
  async seeCCTR(template: TemplateRef<any>, sRequestID) {
    let cctrData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminReverseFIdoc/GetsCCTR", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  async seeFIDoc(template: TemplateRef<any>, sRequestID) {
    let cctrData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminReverseFIdoc/GetFIDoc", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrFIDoc = JSON.parse(data);
      if (this.arrFIDoc) {
        if (this.arrFIDoc.length > 0) {
          this.isShowFIDoc = this.arrFIDoc[0].nFIDoc > 0;
          this.isShowClearingDoc = this.arrFIDoc[0].nClearingDoc > 0;
          this.isShowAdvClearingDoc = this.arrFIDoc[0].nAdvClearingDoc > 0;
          this.isShowRecieveDoc = this.arrFIDoc[0].nRecieveDoc > 0;
        }
      }
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  async OpensModal(template: TemplateRef<any>, sRequestID) {
    let CHK = this._ArrData.filter(f => f.sRequestID == sRequestID);
    var checkFIDoc = true;
    if (CHK.length > 0) {
      checkFIDoc = CHK[0].sFIDoc !== "";
    }
    if (checkFIDoc) {
    this.sReverseForm.get('dReversingDate').setValue(this.formatDate(new Date(CHK[0].dPostingDate)));
      this.sReverseForm.get('sRequestID').setValue(sRequestID);
    
      const config: ModalOptions = { class: 'gray modal-sm' };
      this.modalRef = this.modalService.show(template, config);
    }
    else {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error_NoFIDoc, function () { });
    }
  }

   padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

   formatDate(date) {
    return [
      this.padTo2Digits(date.getDate()),
      this.padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join('/');
  }

  reverseFIDoc() {
    this.modalRef.hide();
    
    let cctrData = {
      sRequestID: this.sReverseForm.controls.sRequestID.value,
      dReversingDate: this.sReverseForm.controls.dReversingDate.value
    }
    let sendData = JSON.stringify(cctrData)
    if (sendData != null) {
      let This = this;
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, This.SW.BoxMsg.Desc_Confirm_Reverse, function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });

        This.http.post(This.System.SiteName + "api/AdminReverseFIdoc/Save", sendData, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, This.SW.BoxMsg.Desc_Success_Reverse, function () {
              This.Search();
            });
          }
          else {
            This.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, s, function () { });
          }
        })
      }, function () { });
    }
  }

  returnFIDoc(sRequestID) {
    let cctrData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(cctrData)
    if (sendData != null) {
      let This = this;
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, This.SW.BoxMsg.Desc_Confirm_Return, function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });

        This.http.post(This.System.SiteName + "api/AdminReverseFIdoc/Return", sendData, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, This.SW.BoxMsg.Desc_Success_Reverse, function () {
              This.Search();
            });
          }
          else {
            this.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, s, function () { });
          }
        })
      }, function () { });


    }
  }

  getFIDocSearch(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("COMPANY_CODE", sCompany)
    };
    this.http.get<any>(this.System.SiteName + "api/AdminReverseFIdoc/GetFIDocSearch", httpOptions).toPromise().then(res => {
      if (res) {
        this.FIDoc = res;
        this._FIDoc = this.FIDoc;
      }
    });
  }

  onSelect(event) {
    this.FilterGrid.sFIDoc = event.item.sFIDoc;
  }

  typeaheadOnBlur(event) {
    if (this.FilterGrid.sFIDoc) {
      this.FilterGrid.sFIDoc = null;
    } else {
      let sFIDoc = this.FilterGrid.sFIDoc.trim();
      let CHK = this._FIDoc.filter(f => f.sFIDoc == sFIDoc);
      if (CHK.length > 0) {
        this.onSelect(event)
      }
      else {
        this.FilterGrid.sFIDoc = ""
      }
    }
  }

  onselect_com(item: any) {
    let _data: string[] = [];
    let sCompCode = "";
    for (let i = 0; i < this.FilterGrid.sCompanyCode.length; i++) {
      _data.push(this.FilterGrid.sCompanyCode[i].COMPANY_CODE);
    }
    sCompCode = _data.join(',');
    this.getFIDocSearch(sCompCode);
  }

  onselectall_com(item: any) {
    let _data: string[] = [];
    let sCompCode = "";
    for (let i = 0; i < item.length; i++) {
      _data.push(item[i].COMPANY_CODE);
    }
    sCompCode = _data.join(',');
    this.getFIDocSearch(sCompCode);
    this.FilterGrid.sCompanyCode = item;
  }

  onDeselect_com(item: any) {
    this.getFIDocSearch('');
    this.FilterGrid.sCompanyCode = item;
  }

  clearDisplayError() {
    this.sReverseForm.reset();
    this.modalRef.hide();
  }

}
